import { render, staticRenderFns } from "./IndexSheet.vue?vue&type=template&id=062050dc&"
import script from "./IndexSheet.vue?vue&type=script&lang=js&"
export * from "./IndexSheet.vue?vue&type=script&lang=js&"
import style0 from "./IndexSheet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports